<template>
    <div class="bg-slate-50 rounded-2xl shadow-inner p-4 lg:px-6">
        <div class="flex flex-col gap-2 lg:flex-row lg:justify-between lg:items-center">
            <div class="text-sm">
                <slot name="label"></slot>
            </div>
            <div>
                <vx-toggle v-model="model"></vx-toggle>
            </div>
        </div>
        <div v-if="props.open"
            class="border-t border-solid border-x-0 border-b-0 border-slate-300 pt-4 mt-4">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { VxToggle } from '@voxie/frontend-components';

const model = defineModel({
    type: Boolean,
    default: false,
});
const props = defineProps({ open: Boolean })

</script>
